import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { useSelector } from "react-redux";
import KeyModal from './KeyModal';
import { api } from '../../api';
import { customStyles } from "../../styles/dataTableStyles";

export default function PurchaseProduct() {
  const token = useSelector((state) => state.auth.token);
  const [showProductKey, setShowProductKey] = useState(false);
  const [transactionId, setTransactionId] = useState([]);
  const [quantity, setQuantity] = useState(null);
  const [listData, setListData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10); // Default page size
  const [search, setSearch] = useState("");


  const fetchData = async (pageNo, searchKey, pageSize) => {
    setLoading(true);
    try {
      const res = await api.products.getTransactionHistory({pageNo, pageSize, sort: "asc", sortBy: "masterProductName", searchKey }, token); // you can pass pageNo, searchKey, pageSize if needed
      setTableData(Array.isArray(res.data.result) ? res.data.result : []);
      setTotalRows(res.data.totalCount);
    } catch (error) {
      console.error("Error fetching transaction history:", error);
    } finally {
      setLoading(false);
    }
   };

  useEffect(() => {
    fetchData(page, search, pageSize);
 // eslint-disable-next-line
  }, [page, search, pageSize]);

  const showKey = (id, quantity) => {
    setShowProductKey(true);
    setTransactionId(id);
    setQuantity(quantity);

    api.products
      .getTransactionListById({ transactionId: id, pageSize: '50', pageNo: '1' },token)
      .then((res) => setListData(Array.isArray(res.data) ? res.data : []));
  };

  const closeModal = () => {
    setShowProductKey(false);
    setListData([]);
  };

  // eslint-disable-next-line
  const handleRowClick = (row) => {
    if (row.scheduleStatus === 'Completed') {
      showKey(row.transactionId, row.quantity);
    }
  };

  const columns = [
    {
      name: 'Id',
      selector: (row) => row.transactionId,
      cell: (row) => (
        <>
          <input type="hidden" value={row.transactionId} />
          <span>{row.transactionId}</span>
        </>
      ),
    },
    {
      name: 'Created',
      selector: (row) => row.createdDate,
      cell: (row) => (
        <span>{new Date(row.createdDate).toLocaleDateString('en-ca')}</span>
      ),
    },
    {
      name: 'Master Product Name',
      selector: (row) => row.masterProductName,
      cell: (row) =>
        row.masterProductName ? (
          <span className="add-ellip">{row.masterProductName}</span>
        ) : (
          ''
        ),
    },
    {
      name: 'Purchased Quantity',
      selector: (row) => row.quantity,
    },
    {
      name: 'Merchant Name',
      selector: (row) => row.merchantName,
      cell: (row) =>
        row.merchantName ? (
          <span className="add-ellip">{row.merchantName}</span>
        ) : (
          ''
        ),
    },
    {
      name: 'Schedule Status',
      selector: (row) => row.scheduleStatus,
    },
  ];

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
          <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="sec-header">PRODUCT PULL REQUEST LIST</h2>
        <div className="d-flex align-items-center">
          <label className="mr-2">Search:</label>
          <input
            type="text"
            placeholder="Search"
            className="form-control"
            style={{ width: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

      
                </div>
              </div>

            <div className="card card-table">
          
                <div className="reports">

                <DataTable
                  columns={columns}
                  data={tableData}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangePage={setPage}
                  onChangeRowsPerPage={(newPageSize, newPage) => {
                    setPageSize(newPageSize);
                    setPage(newPage); // Reset to selected page
                  }}
                  highlightOnHover
                  customStyles={customStyles} // Apply custom styles
                  responsive // ✅ Enable responsive mode
                  noHeader={false}
                  noTableHead={false}
                  wrap // ✅ Prevents horizontal scroll
                />
                          

                  {showProductKey && (
                    <KeyModal
                      showModal={showProductKey}
                      closeModal={closeModal}
                      transactionId={transactionId}
                      quantity={quantity}
                      listData={listData}
                    />
                  )}
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
